import React from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import "./axios/index";
import i18n from "./i18n";
import "./index.scss";
import Routers from "./routes";
import store from "./store";

const Root = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <BrowserRouter basename={"/"}>
          <Routers />
        </BrowserRouter>
        <Toaster />
      </Provider>
    </I18nextProvider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Root />);
